import {
  Grid,
  Card,
  Select,
  TextInput,
  Button,
  NumberInput,
  Text,
  ScrollArea,
  ActionIcon,
  Group,
  Paper,
  Divider,
  Menu,
  Modal,
  NativeSelect,
  Pagination,
  Table,
} from "@mantine/core"; //For import mantine required functions and theme
import React, { useEffect, useState, useRef, forwardRef } from "react";
import {
  handleAddCustomer,
  handleAddInvoice2,
  handleDeleteSaveInvoice,
  handleGetAllProductStock,
  handleGetBank,
  handleGetCustomer,
  handleGetGroup,
  handleGetInvoice,
  handleGetOneSaveInvoice,
  handleGetPacketStock,
  handleGetProduct,
  handleGetProductPacketStock,
  handleGetProductStock,
  handleGetSaleType,
  handleGetSaveInvoice,
  handleGetStock,
  handleGetStockType,
  handleSaveInvoice,
} from "../../helpers/apis"; // For connect to the electron backend from this helper apis
import { dataSlice, selectFilter } from "../../helpers/common";
import { useForm } from "@mantine/form"; // Mantine form import
import { DatePicker } from "@mantine/dates";
import { Plus, Trash, X, Dots, Eye, Search } from "tabler-icons-react"; // For particular icons that has used in this page from tabler icon
import useStyles from "../../components/Style";
import notificationHelper from "../../helpers/notification";
import { useNavigate } from "react-router-dom"; // For import the react dom for navigation components
import { dataSearch, Th } from "../../helpers/tableFunction";
import { useModals } from "@mantine/modals";

function AddSale() {
  const targetRef = useRef(null);
  const { classes } = useStyles();
  const [cart, setCart] = useState([]);
  const [saleTypeValue, setSaleTypeValue] = useState("Cash");
  const [saleTypeBank, setSaleTypeBank] = useState(null);
  const [detailsModal, setDetailModal] = useState(false);
  const [savedModal, setSavedModal] = useState(false);
  const [tableRefresh, setTableRefresh] = useState(new Date());
  const [validateBarcode, setValidateBarcode] = useState(0);
  const [customer, setCustomer] = useState("");
  let navigate = useNavigate();
  const [variables, setVariables] = useState({
    addDrawer: false,
    data: [],
    skeletonLoading: false,
    submitLoading: false,
    productBarcode: false,
    invoiceList: [],
    productList: [],
    packetList: [],
    groupList: [],
    stockTypeList: [],
    taxList: [],
    customer: [],
    saleType: [],
    banksList: [],
    amountPaid: 0,
    invoiceDiscount: 0,
    stocks: [],
    packet_stock: [],
    invoiceDate: new Date(),
  });
  const modals = useModals();
  // Setting the variables data for table data
  const [sortedData, setSortedData] = useState([]); // For table data
  const [activePage, setPage] = useState(1); // For set table active page
  const [total, setTotal] = useState(10); // For set total list show in page
  const [search, setSearch] = useState(""); // For set the search value name of table
  const [sortBy, setSortBy] = useState(null); // Seting the sortby table type
  const [reverseSortDirection, setReverseSortDirection] = useState(false); // For set the reverse sort direction
  const [refreshTable, setRefreshTable] = useState(Date.now()); // For refresh table
  const [lastInvoice, setLastInvoice] = useState("");
  const [bulkstock, setBulkstock] = useState(0);
  const [packetstock, setPacketstock] = useState(0);
  const [bulkprice, setBulkprice] = useState(0);
  const [packetprice, setPacketprice] = useState(0);
  const [entryType, setEntrytype] = useState("Product Quantity (KG's)");

  const form = useForm({
    initialValues: {
      customer: "",
      category: "",
      product: "",
      stock_type: "",
      gst: "",
      qty: 1,
      discount: 0,
      barcode: "",
      price: 0,
      discount_type: "number",
      invoiceTotal: "",
    },
    validate: {
      qty: (value) => (value < 1 ? "Quantity should have minimum 1" : null),
    },
  });

  const formBarcode = useForm({
    initialValues: {
      barcode: "",
      product_name: "",
      product: "",
      price: 0,
      quantity: 1,
      discountType: "number",
      discount: "",
    },
  });

  const formCustomer = useForm({
    initialValues: {
      name: "",
      phone_number: "",
      credit_limit: 0,
      gstin: "",
      door_no: "",
      street: "",
      locality: "",
      pincode: "",
      city: "",
      state: "",
    },
    validate: {
      name: (value) => (value.length < 1 ? "Customer name is required" : null),
      phone_number: (value) =>
        value.length < 10 ? "Phone name is required" : null,
    },
  });

  const AddCustomer = async (e) => {
    setVariables({ ...variables, submitLoading: true });
    const response = await handleAddCustomer(e);
    // Check for response for actions
    if (response.status === 200) {
      notificationHelper({
        color: "green",
        title: "Success",
        message: "Customer added successfully",
      });
      formCustomer.reset();
      const listGroup = await selectFilter({
        data: response.data.data,
      });

      setVariables((variables) => {
        return {
          ...variables,
          customer: listGroup,
          submitLoading: false,
        };
      });
    } else {
      notificationHelper({
        color: "red",
        title: "Failed! Please enter correct details",
        message: response.data.message,
      });
      setVariables({ ...variables, submitLoading: false });
    }
  };

  const formDetails = useForm({
    initialValues: {
      deliver_note: "",
      suppliers_ref: "",
      other_ref: "",
      buyer_order_no: "",
      dated: "",
      despatch_doc_no: "",
      delivery_note_date: "",
      despatched_through: "",
      destination: "",
      terms_of_delivery: "",
      remark: "",
    },
  });

  useEffect(() => {
    let mounted = true;
    const fetchData = async () => {
      const response1 = await handleGetStockType();
      // On Response setting the data to variable
      console.log(response1);
      if (response1.status === 200) {
        const listGroup = await selectFilter({
          data: response1.data.data,
        });
        setVariables((variables) => {
          return {
            ...variables,
            stockTypeList: listGroup,
          };
        });
      }

      const response2 = await handleGetCustomer();
      // On Response setting the data to variable
      if (response2.status === 200) {
        const listGroup = await selectFilter({
          data: response2.data.data,
        });

        setVariables((variables) => {
          return {
            ...variables,
            customer: listGroup,
          };
        });
      }

      const response3 = await handleGetGroup();
      // On Response setting the data to variable
      if (response3.status === 200) {
        const listGroup = await selectFilter({
          data: response3.data.data,
        });
        setVariables((variables) => {
          return {
            ...variables,
            groupList: listGroup,
          };
        });
      }

      const response6 = await handleGetProduct();
      // On Response setting the data to variable
      if (response6.status === 200) {
        const response9 = await handleGetProductStock();
        if (response9.status === 200) {
          const productStock = response9.data.data;

          const listGroup = await response6.data.data.map((data) => ({
            ...data,
            value: data.value.toString(),
            stock: productStock.reduce(function (sum, img) {
              if (Number(img.value) == Number(data.value)) {
                return +Number(sum) + +Number(img.max_remaining);
              } else {
                return sum;
              }
            }, 0),
            label: data.label.toString(),
          }));
          listGroup.forEach(function (item) {
            delete item.createdAt;
            delete item.updatedAt;
            delete item.category;
          });
          console.log(listGroup);
          setVariables((variables) => {
            return {
              ...variables,
              productList: listGroup,
            };
          });
        } else {
          const listGroup = await response6.data.data.map((data) => ({
            ...data,
            value: data.value.toString(),
            label: data.label.toString(),
          }));
          listGroup.forEach(function (item) {
            delete item.createdAt;
            delete item.updatedAt;
            delete item.category;
          });
          setVariables((variables) => {
            return {
              ...variables,
              productList: listGroup,
            };
          });
        }
      }

      const responsePack = await handleGetPacketStock();
      // On Response setting the data to variable
      if (responsePack.status === 200) {
        console.log(responsePack.data);
        const listGroup = await responsePack.data.data.map((data) => ({
          value: data.value.toString(),
          label: data.product.label.toString(),
        }));
        setVariables((variables) => {
          return {
            ...variables,
            packetList: listGroup,
          };
        });
        console.log(variables.packetList);
      }

      const response7 = await handleGetSaleType();
      // On Response setting the data to variable
      if (response7.status === 200) {
        const listGroup = await response7.data.data.map((data) => ({
          value: data.value.toString(),
          label: data.label.toString(),
        }));
        setVariables((variables) => {
          return {
            ...variables,
            saleType: listGroup,
          };
        });
      }

      const response8 = await handleGetBank();

      // On Response setting the data to variable
      if (response8.status === 200) {
        const listGroup = await response8.data.data.map((data) => ({
          value: data.value.toString(),
          label: data.label.toString(),
        }));
        setVariables((variables) => {
          return {
            ...variables,
            banksList: listGroup,
          };
        });
        console.log(variables.banksList);
      }

      const response9 = await handleGetStock();

      // On Response setting the data to variable
      if (response9.status === 200) {
        setVariables((variables) => {
          return {
            ...variables,
            stocks: response9.data.data,
          };
        });
      }

      const response12 = await handleGetPacketStock();

      // On Response setting the data to variable
      if (response12.status === 200) {
        setVariables((variables) => {
          return {
            ...variables,
            packet_stock: response12.data.data,
          };
        });
      }

      const response10 = await handleGetSaveInvoice();

      // On Response setting the data to variable
      if (response10.status === 200) {
        setVariables((variables) => {
          return {
            ...variables,
            data: response10.data.data,
          };
        });
        const datas = dataSlice({
          data: response10.data.data,
          page: 1,
          total: 10,
        });
        setSortedData(datas);
      }
      // For get the all invoices
      const response11 = await handleGetInvoice();
      // On Response setting the data to variable
      if (response11.status === 200) {
        setVariables((variables) => {
          return {
            ...variables,
            invoiceList: response11.data.data,
          };
        });
        if (response11.data.data.length > 0) {
          var data77 = response11.data.data;
          var datao = data77[data77.length - 1];
          setLastInvoice(datao.invoice_date);
        }
      }
    };
    fetchData();
    return () => {
      mounted = false;
    };
  }, []);

  const rows = sortedData.map((row, index) => (
    <tr key={row.label}>
      <td>{activePage * total - total + index + 1}</td>
      <td>{row.invoice_number}</td>
      <td>{row.customer_id}</td>
      <td>{row.discount}</td>
      <td>{row.sub_total}</td>
      <td>{row.cgst}</td>
      <td>{row.sgst}</td>
      <td>{row.total}</td>
      <td>
        {new Date(row.invoice_date).toLocaleString("en-US", {
          hour12: true,
        })}
      </td>
      <td>
        <Button
          color="green"
          size="xs"
          onClick={async () => {
            const reg = {
              value: row.value,
            };

            const response = await handleGetOneSaveInvoice(reg);
            console.log(response.data.save_invoice_items);

            if (response.status === 200) {
              var data_list = response.data.save_invoice_items;
              var list = [];
              for (let i = 0; i < data_list.length; i++) {
                var total = Number(
                  (Number(data_list[i].rate) - Number(0)) *
                    Number(data_list[i].count)
                ).toFixed(2);
                var pick = {
                  category: data_list[i].product.category,
                  product: data_list[i].product,
                  stock_type: data_list[i].stock_type,
                  price: data_list[i].rate,
                  tax_per: data_list[i].product.tax,
                  tax: Number(
                    (data_list[i].product.tax / 2 / 100) * Number(total)
                  ).toFixed(2),
                  qty: Number(data_list[i].count),
                  discount: Number(data_list[i].discount),
                  total: Number(data_list[i].amount),
                };
                list.push(pick);
              }
              setCart(list);
              setSavedModal(false);
            }
          }}
        >
          Load
        </Button>
      </td>
      {/* For action drop down edit and delete the data */}
      <td justifycontent="right" align="right">
        <Menu shadow="sm" size="xs">
          <Menu.Target>
            <ActionIcon
              color="zevcore"
              type="button"
              style={{ marginLeft: 5 }}
              size="xs"
            >
              <Dots />
            </ActionIcon>
          </Menu.Target>
          <Menu.Dropdown>
            <Menu.Item
              style={{ fontSize: 12 }}
              onClick={() => openConfirmModal(row.value)}
            >
              Delete
            </Menu.Item>
          </Menu.Dropdown>
        </Menu>
      </td>
    </tr>
  ));

  //For delete confirm modal show Delete
  const openConfirmModal = (e) => {
    setSavedModal(false);
    setVariables({ ...variables, deleteIndex: e });
    modals.openConfirmModal({
      title: "Do you want to delete this sale value",
      labels: { confirm: "Confirm", cancel: "Cancel" },
      confirmProps: { color: "red" },
      onCancel: () => setSavedModal(true),
      onConfirm: () => handleConfirmDelete(e),
    });
  };

  //   For delete db data from table and db
  const handleConfirmDelete = async (e) => {
    const response = await handleDeleteSaveInvoice(e);
    // Check the response for notification and actions

    if (response.status === 200) {
      notificationHelper({
        color: "green",
        title: "Success",
        message: "Saved Sale deleted successfully",
      });
      var filter = variables.data;
      filter = filter.filter((img) => img.value !== e);
      setVariables({
        ...variables,
        submitLoading: false,
        data: filter,
      });
      const datas = dataSlice({
        data: filter,
        page: activePage,
        total: total,
      });
      setSortedData(datas);
    } else {
      notificationHelper({
        color: "red",
        title: "Failed! Please enter correct details",
        message: response.data.message,
      });
      setVariables({ ...variables, submitLoading: false });
    }
  };

  const DeleteProduct = (e) => {
    var check = cart.findIndex(
      (img) =>
        Number(img.product.stock_type) === Number(e.stock_type) &&
        Number(img.product.value) === Number(e.product)
    );
    var data = cart;
    data.splice(check, 1);
    setCart(data);
    setTableRefresh(new Date());
  };

  var mergeTwoLists = function (list1, list2) {
    var array = [];
    for (let i = 0; i < list1; i++) {
      array[i].push(list1[i], list2[i]);
    }
    return array;
  };

  // Add Product to cart function
  const AddProduct = (e) => {
    setVariables({ ...variables, productBarcode: true });
    var check = cart.find(
      (img) =>
        Number(img.product.value) === Number(e.product) &&
        img.stock_type === e.stock_type
    );

    if (check !== null && typeof check != "undefined") {
      var dataList = cart;
      var check = cart.findIndex(
        (img) =>
          img.product.value === e.product && img.stock_type === e.stock_type
      );

      if (e.stock_type === dataList[check].stock_type) {
        var discount = 0;
        if (e.discount_type == "number") {
          discount = e.discount;
        } else {
          discount = (Number(e.discount) / 100) * e.price;
        }
        var product = variables.productList.find(
          (img) => Number(img.value) === Number(e.product)
        );
        var total = Number(
          (Number(e.price) - Number(discount)) *
            (Number(e.qty) + Number(dataList[check].qty))
        ).toFixed(2);
        var list = {
          category: variables.groupList.find(
            (img) => Number(img.value) === Number(e.category)
          ),
          product: variables.productList.find(
            (img) => Number(img.value) === Number(e.product)
          ),
          barcode: e.barcode,
          stock_type: e.stock_type,
          price: e.price,
          tax_per: product.tax,
          tax: Number((product.tax / 2 / 100) * Number(total)).toFixed(2),
          qty: Number(e.qty) + Number(dataList[check].qty),
          discount: discount * (Number(e.qty) + Number(dataList[check].qty)),
          total: total,
        };
        dataList[check] = list;
        setCart(dataList);
        setTableRefresh(new Date());
      } else {
        var discount = 0;
        if (e.discount_type == "number") {
          discount = e.discount;
        } else {
          discount = (Number(e.discount) / 100) * e.price;
        }
        var product = variables.productList.find(
          (img) => Number(img.value) === Number(e.product)
        );
        var total = Number(
          (Number(e.price) - Number(discount)) * Number(e.qty)
        ).toFixed(2);

        var list = {
          category: variables.groupList.find(
            (img) => Number(img.value) === Number(e.category)
          ),
          product: variables.productList.find(
            (img) => Number(img.value) === Number(e.product)
          ),
          stock_type: e.stock_type,
          tax_per: product.tax,
          tax: Number((product.tax / 2 / 100) * Number(total)).toFixed(2),
          price: e.price,
          qty: e.qty,
          discount: discount * e.qty,
          total: total,
        };
        var data = cart;
        data.push(list);
        setCart(data);
        setTableRefresh(new Date());
      }
    } else {
      if (e.stock_type === "Bulk") {
        var discount = 0;
        if (e.discount_type == "number") {
          discount = e.discount;
        } else {
          discount = (Number(e.discount) / 100) * e.price;
        }
        var product = variables.productList.find(
          (img) => Number(img.value) === Number(e.product)
        );
        var total = Number(
          (Number(e.price) - Number(discount)) * Number(e.qty)
        ).toFixed(2);

        var list = {
          category: variables.groupList.find(
            (img) => Number(img.value) === Number(e.category)
          ),
          product: variables.productList.find(
            (img) => Number(img.value) === Number(e.product)
          ),
          stock_type: e.stock_type,
          tax_per: product.tax,
          tax: Number((product.tax / 2 / 100) * Number(total)).toFixed(2),
          price: e.price,
          qty: e.qty,
          discount: discount * e.qty,
          total: total,
        };

        var data = cart;
        data.push(list);
        setCart(data);
        setTableRefresh(new Date());
      } else {
        var discount = 0;
        if (e.discount_type == "number") {
          discount = e.discount;
        } else {
          discount = (Number(e.discount) / 100) * e.price;
        }
        var product = variables.productList.find(
          (img) => Number(img.value) === Number(e.product)
        );
        var total = Number(
          (Number(e.price) - Number(discount)) * Number(e.qty)
        ).toFixed(2);

        var list = {
          category: variables.groupList.find(
            (img) => Number(img.value) === Number(e.category)
          ),
          product: variables.productList.find(
            (img) => Number(img.value) === Number(e.product)
          ),
          stock_type: e.stock_type,
          tax_per: product.tax,
          tax: Number((product.tax / 2 / 100) * Number(total)).toFixed(2),
          price: e.price,
          qty: e.qty,
          discount: discount * e.qty,
          total: total,
        };
        var data = cart;
        data.push(list);
        setCart(data);
        setTableRefresh(new Date());
      }
    }
    form.reset();

    if (cart.length > 20) {
      targetRef.current.scrollIntoView({
        behavior: "smooth",
        block: "end",
        inline: "nearest",
      });
    }
    setVariables({ ...variables, productBarcode: false });
  };

  const handelKeyPress = (e) => {
    if (e.key === "Enter") {
      input0.current.blur();
      input1.current.focus();
    }
  };

  const formRef = useRef();
  const input0 = useRef();
  const input1 = useRef();
  const input2 = useRef();
  const input3 = useRef();
  const input4 = useRef();
  const input5 = useRef();
  const input6 = useRef();
  const input7 = useRef();
  const input8 = useRef();

  const barcode = (e) => {
    var barcode = e.target.value;
    const stockList = variables.stocks;
    const packet_stockList = variables.packet_stock;
    const finding = stockList.find((img) => img.barcode === barcode);
    const finding1 = packet_stockList.find((img) => img.barcode === barcode);
    if (typeof finding != "undefined" && finding != "" && finding != null) {
      formBarcode.setFieldValue("barcode", "");
      form.setFieldValue("barcode", e.target.value.toString());
      form.setFieldValue("product", finding.product.value.toString());
      form.setFieldValue("category", finding.product.category.value.toString());
      form.setFieldValue("stock_type", "Bulk");
      form.setFieldValue("price", Number(finding.product.bulk_price));
      // setBulkstock()
    } else if (
      typeof finding1 != "undefined" &&
      finding1 != "" &&
      finding1 != null
    ) {
      formBarcode.setFieldValue("barcode", "");
      form.setFieldValue("barcode", e.target.value.toString());
      form.setFieldValue("product", finding1.product.value.toString());
      form.setFieldValue(
        "category",
        finding1.product.category.value.toString()
      );
      form.setFieldValue("stock_type", "Packet");
      form.setFieldValue("price", Number(finding1.product.unit_price));
    } else {
      setValidateBarcode(2);
    }
    setTimeout(() => {
      setValidateBarcode(0);
    }, 3000);
  };

  const selRef = useRef();

  const SelectItem = forwardRef(({ image, label, stock, ...others }) => (
    <div ref={selRef} {...others}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Text size="sm">{label}</Text>
        <Text size="xs" color="dark">
          {stock}
        </Text>
      </div>
    </div>
  ));

  const selRef1 = useRef();

  const SelectItem1 = forwardRef(({ image, label, stock, ...others }) => (
    <div ref={selRef1} {...others}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Text size="sm">{label}</Text>
        <Text size="xs">{stock}</Text>
      </div>
    </div>
  ));

  const handleStock = async (e) => {
    const response_stock = await handleGetAllProductStock(e);
    if (response_stock.status === 200) {
      setBulkstock(response_stock.data.data[0].max_remaining);
      setPacketstock(response_stock.data.data[0].max_remaining_quantity);
      setBulkprice(response_stock.data.data[0].bulk_price);
      setPacketprice(response_stock.data.data[0].unit_price);
    }
  };

  // Add sale invoice data
  const AddSaleData = async () => {
    var first = new Date(lastInvoice).setHours(0, 0, 0, 0);
    var second = new Date(variables.invoiceDate).setHours(0, 0, 0, 0);
    var third = new Date().setHours(0, 0, 0, 0);

    var check = 0;
    if (lastInvoice != "") {
      if (first <= second && second <= third) {
        check = 0;
      } else {
        check = 1;
      }
    }
    if (check == 0) {
      var customerId = "";
      if (form.values.customer !== null && form.values.customer !== "") {
        var data = variables.customer.find(
          (img) => Number(img.value) === Number(form.values.customer)
        );
        customerId = data.value;
      }
      const reg = {
        discountValue: cart
          .reduce(function (sum, current) {
            return +Number(sum) + Number(current.discount);
          }, 0)
          .toFixed(2),
        subTotal: cart.reduce(function (sum, current) {
          return +Number(sum) + Number(current.total);
        }, 0),
        totalTax: Number(
          cart.reduce(function (sum, current) {
            return +Number(sum) + Number(current.tax);
          }, 0)
        ).toFixed(2),
        sale_type: saleTypeValue,
        customer: customerId,
        address: "",
        terms_of_delivery: formDetails.values.terms_of_delivery,
        remark: formDetails.values.remark,
        destination: formDetails.values.destination,
        despatched_through: formDetails.values.despatched_through,
        delivery_note_date: formDetails.values.delivery_note_date,
        despatch_doc_no: formDetails.values.despatch_doc_no,
        dated: formDetails.values.dated,
        buyer_order_no: formDetails.values.buyer_order_no,
        other_ref: formDetails.values.other_ref,
        suppliers_ref: formDetails.values.suppliers_ref,
        deliver_note: formDetails.values.deliver_note,
        bank_name: saleTypeBank,
        grand_total:
          cart.reduce(function (sum, current) {
            return +Number(sum) + Number(current.total);
          }, 0) +
          cart.reduce(function (sum, current) {
            return +Number(sum) + Number(current.tax);
          }, 0),
        list: cart,
        balance:
          cart.reduce(function (sum, current) {
            return +Number(sum) + Number(current.total);
          }, 0) +
          cart.reduce(function (sum, current) {
            return +Number(sum) + Number(current.tax);
          }, 0) -
          (Number(variables.amountPaid) + Number(variables.invoiceDiscount)),
        paid: variables.amountPaid,
        invoiceDiscount: variables.invoiceDiscount,
        date: variables.invoiceDate,
      };
      const response = await handleAddInvoice2(reg);
      console.log(response.data);
      if (response.status === 200) {
        navigate("/print_invoice/" + response.data.data[0].value);

        notificationHelper({
          color: "green",
          title: "Success",
          message: "Invoice added successfully",
        });
      } else {
        notificationHelper({
          color: "red",
          title: "Failed! Please enter correct details",
          message: response.data.message,
        });
      }
    } else {
      alert("Please select & customer invoice date correctly");
    }
  };

  const handleSaveSale = async () => {
    var customerId = form.values.customer;
    if (form.values.customer !== null && form.values.customer !== "") {
      var data = variables.customer.find(
        (img) => Number(img.value) === Number(form.values.customer)
      );
      customerId = form.values.customer;
    }
    const reg = {
      discountValue: cart
        .reduce(function (sum, current) {
          return +Number(sum) + Number(current.discount);
        }, 0)
        .toFixed(2),
      subTotal: cart.reduce(function (sum, current) {
        return +Number(sum) + Number(current.total);
      }, 0),
      totalTax: Number(
        cart.reduce(function (sum, current) {
          return +Number(sum) + Number(current.tax);
        }, 0)
      ).toFixed(2),
      sale_type: saleTypeValue,
      customer: customerId,
      address: "",
      terms_of_delivery: formDetails.values.terms_of_delivery,
      remark: formDetails.values.remark,
      destination: formDetails.values.destination,
      despatched_through: formDetails.values.despatched_through,
      delivery_note_date: formDetails.values.delivery_note_date,
      despatch_doc_no: formDetails.values.despatch_doc_no,
      dated: formDetails.values.dated,
      buyer_order_no: formDetails.values.buyer_order_no,
      other_ref: formDetails.values.other_ref,
      suppliers_ref: formDetails.values.suppliers_ref,
      deliver_note: formDetails.values.deliver_note,
      bank_name: saleTypeBank,
      grand_total:
        cart.reduce(function (sum, current) {
          return +Number(sum) + Number(current.total);
        }, 0) +
        cart.reduce(function (sum, current) {
          return +Number(sum) + Number(current.tax);
        }, 0),
      list: cart,
      balance:
        cart.reduce(function (sum, current) {
          return +Number(sum) + Number(current.total);
        }, 0) +
        cart.reduce(function (sum, current) {
          return +Number(sum) + Number(current.tax);
        }, 0) -
        (Number(variables.amountPaid) + Number(variables.invoiceDiscount)),
      paid: variables.amountPaid,
      invoiceDiscount: variables.invoiceDiscount,
      date: variables.invoiceDate,
    };
    const response = await handleSaveInvoice(reg);
    if (response.status === 200) {
      notificationHelper({
        color: "green",
        title: "Success",
        message: "Invoice saved successfully",
      });
      formDetails.reset();
      form.reset();
      setSaleTypeBank("");
      setCustomer(null);
      setVariables({ ...variables, amountPaid: 0, invoiceDate: new Date() });
      setCart([]);
      setTotal(0);
      setSaleTypeValue(null);
    } else {
      notificationHelper({
        color: "red",
        title: "Failed! Please enter correct details",
        message: response.data.message,
      });
    }
  };

  return (
    <div>
      {" "}
      <Grid pb={0} gutter="xs" classNames="zc-hide-scroll">
        <Grid.Col
          xs={4}
          className="invoiceItemLeft"
          style={{ display: "flex" }}
        >
          <Card p={0} className="border">
            <div
              style={{
                display: "flex",
                padding: 0,
                margin: 0,
                justifyContent: "space-between",
                background: "#043c64",
                borderTopRightRadius: 3,
                borderTopLeftRadius: 3,
              }}
            >
              <Text color="#ffffff" size={14} m={5} mt={8} ml={15}>
                Create Invoice
              </Text>
            </div>

            <div style={{ padding: 15 }}>
              {/* For add new customer or selct customer */}

              <Grid grow gutter="xs">
                <Grid.Col span={12}>
                  {/* Select or add new customer for selection */}
                  <div
                    style={{
                      display: "flex",
                      marginTop: 0,
                      justifyContent: "space-between",
                    }}
                  >
                    <Text style={{ fontSize: 14 }}>Select Customer</Text>
                    <Button
                      color="zevcore"
                      onClick={() =>
                        setVariables({ ...variables, addDrawer: true })
                      }
                      style={{ fontSize: 10, padding: 2, height: 15 }}
                    >
                      Add <Plus size={10} />
                    </Button>
                  </div>

                  <Select
                    variant="filled"
                    fullWidth
                    dropdownPosition="bottom"
                    searchable
                    clearable
                    required
                    withAsterisk
                    placeholder="Select Customer"
                    data={variables.customer}
                    value={customer}
                    {...form.getInputProps("customer")}
                    mr={2}
                  />
                  {/* Invoice date pick */}
                  <DatePicker
                    variant="filled"
                    value={variables.invoiceDate}
                    onChange={(e) =>
                      setVariables({
                        ...variables,
                        invoiceDate: e,
                      })
                    }
                    label="Invoice Date"
                    placeholder="Pick date"
                    required
                  />
                </Grid.Col>
              </Grid>
              <Divider
                my="xs"
                label="Product Barcode Enter"
                labelPosition="center"
              />
              <Grid>
                {/* For entering the barcode data of product for auto fetch subgroup and group and product details */}
                <Grid.Col span={12}>
                  <TextInput
                    variant="filled"
                    size="xs"
                    label="Product Barcode"
                    placeholder="Product Barcode"
                    onKeyDown={barcode}
                    {...formBarcode.getInputProps("barcode")}
                  />
                  {validateBarcode == 1 ? (
                    <Text mt={2} color={"green"} size="xs">
                      Item added to cart success
                    </Text>
                  ) : validateBarcode == 2 ? (
                    <Text mt={2} color={"red"} size="xs">
                      No item found for this barcode
                    </Text>
                  ) : (
                    <Text mt={2} size="xs">
                      &nbsp;
                    </Text>
                  )}
                </Grid.Col>
              </Grid>
              <Divider my="xs" label="Product Select" labelPosition="center" />
              {/* For adding the products to carts */}
              <form
                ref={formRef}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                  }
                }}
                onSubmit={form.onSubmit((values) => AddProduct(values))}
              >
                <Grid grow gutter="xs">
                  <Grid.Col span={6}>
                    {/* Select the group */}
                    <Select
                      ref={input0}
                      variant="filled"
                      size="xs"
                      required
                      fullWidth
                      onKeyDown={(e) => {
                        if (form.values.category != "") {
                          if (e.key === "Enter") {
                            input0.current.blur();
                            input1.current.focus();
                          }
                        }
                      }}
                      onKeyUp={(e) => {
                        if (form.values.category != "") {
                          if (e.key === "Enter") {
                            input0.current.blur();
                            input1.current.focus();
                          }
                        }
                      }}
                      dropdownPosition="bottom"
                      label="Select Category"
                      searchable
                      clearable
                      placeholder="Select Category"
                      data={variables.groupList}
                      value={form.values.category}
                      {...form.getInputProps("category")}
                    />
                  </Grid.Col>

                  <Grid.Col span={6}>
                    {/* Select the product */}
                    <Select
                      ref={input3}
                      size="xs"
                      required
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          input3.current.blur();
                          input4.current.focus();
                        }
                      }}
                      onKeyUp={(e) => {
                        if (e.key === "Enter") {
                          input3.current.blur();
                          input4.current.focus();
                        }
                      }}
                      variant="filled"
                      fullWidth
                      label="Select Product"
                      placeholder="Select Product"
                      // itemComponent={SelectItem}
                      data={variables.productList.filter((raw) => {
                        if (Number(form.values.category) != "") {
                          return (
                            Number(raw.category_id) ===
                            Number(form.values.category)
                          );
                        }
                      })}
                      searchable
                      maxDropdownHeight={400}
                      nothingFound="Nobody here"
                      filter={(value, item) =>
                        item.label
                          .toLowerCase()
                          .includes(value.toLowerCase().trim())
                      }
                      onChange={(e) => {
                        var pp = variables.productList.find(
                          (img) => Number(img.value) === Number(e)
                        );
                        form.setFieldValue("price", Number(pp.price));
                        form.setFieldValue("product", e);
                        handleStock(e);
                      }}
                      value={form.values.product}
                    />
                  </Grid.Col>

                  <Grid.Col span={6}>
                    <Select
                      ref={input2}
                      required
                      size="xs"
                      variant="filled"
                      fullWidth
                      itemComponent={SelectItem1}
                      maxDropdownHeight={400}
                      dropdownPosition="bottom"
                      label="Select Stock Type"
                      searchable
                      placeholder="Select Stock Type"
                      data={[
                        {
                          value: "Bulk",
                          label: "Bulk (KG's)",
                          stock: Number(bulkstock / 1000),
                        },
                        {
                          value: "Packet",
                          label: "Units",
                          stock: packetstock,
                        },
                      ]}
                      onChange={(e) => {
                        if (e === "Bulk") {
                          form.setFieldValue("price", bulkprice);
                          form.setFieldValue("stock_type", e);
                        } else {
                          form.setFieldValue("price", packetprice);
                          form.setFieldValue("stock_type", e);
                        }
                      }}
                      value={form.values.stock_type}
                    />
                  </Grid.Col>
                  <Grid.Col span={6}>
                    {/* For enter the quantity */}
                    <NumberInput
                      ref={input5}
                      size="xs"
                      onKeyUp={(e) => {
                        if (e.key === "Enter") {
                          input5.current.blur();
                          input6.current.focus();
                        }
                      }}
                      variant="filled"
                      value={form.values.qty}
                      label={entryType}
                      placeholder="Product Quantity"
                      {...form.getInputProps("qty")}
                    />
                  </Grid.Col>
                  <Grid.Col span={6}>
                    {/* For add the product price */}
                    <NumberInput
                      ref={input4}
                      size="xs"
                      onKeyUp={(e) => {
                        if (e.key === "Enter") {
                          input4.current.blur();
                          input5.current.focus();
                        }
                      }}
                      variant="filled"
                      value={form.values.price}
                      label="Product Price"
                      placeholder="Product Price"
                      {...form.getInputProps("price")}
                    />
                  </Grid.Col>

                  <Grid.Col span={6}>
                    {/* Enter the product discount price */}
                    <NumberInput
                      ref={input4}
                      size="xs"
                      variant="filled"
                      value={
                        (form.values.price - form.values.discount) *
                        form.values.qty
                      }
                      label="Price"
                      placeholder="Price"
                      onChange={(e) => {
                        var price =
                          Number(e - form.values.discount) /
                          Number(form.values.qty);
                        form.setFieldValue("price", Number(price));
                      }}
                    />
                  </Grid.Col>
                  <Grid.Col span={6}>
                    {/* Product discount whole number */}
                    <NumberInput
                      ref={input7}
                      size="xs"
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          input7.current.blur();
                          input8.current.focus();
                        }
                      }}
                      onKeyUp={(e) => {
                        if (e.key === "Enter") {
                          input7.current.blur();
                          input8.current.focus();
                        }
                      }}
                      variant="filled"
                      label="Enter Discount Amount"
                      value={form.values.discount}
                      {...form.getInputProps("discount")}
                      placeholder="Enter whole number"
                    ></NumberInput>
                  </Grid.Col>
                </Grid>
                <div style={{ display: "flex", marginTop: 15 }}>
                  <Button
                    fullWidth
                    type="button"
                    color="zevcore"
                    onClick={() => setDetailModal(true)}
                  >
                    Additional Details
                  </Button>
                  <Button
                    ref={input8}
                    ml={5}
                    // loading={variables.productBarcode}
                    fullWidth
                    type="submit"
                    color="zevcore"
                  >
                    Submit
                  </Button>
                </div>
              </form>
            </div>
          </Card>
        </Grid.Col>
        <Grid.Col xs={8}>
          <Card className="border" pt={2}>
            <div style={{ paddingBottom: 10 }}>
              <Paper className="invoiceItemHeight" px={10}>
                {/* View all the product list cart */}
                <table className="tableBorder" ref={targetRef}>
                  <thead>
                    <tr>
                      <th>Sl.No</th>
                      <th>Description / Item</th>
                      <th>Stock Type</th>
                      <th>Qty</th>
                      <th>Price</th>
                      <th>Discount</th>
                      <th>Total</th>
                      <th>Delete</th>
                    </tr>
                  </thead>
                  <tbody key={tableRefresh}>
                    {cart.length > 0 ? (
                      <>
                        {cart.map((row, index) => (
                          <tr className="products">
                            <td>{index + 1}</td>
                            <td>{row.product.label}</td>
                            <td>{row.stock_type}</td>
                            <td>{row.qty}</td>
                            <td>{row.price}</td>
                            <td>{row.discount}</td>
                            <td>{row.total}</td>
                            <td
                              onClick={() => DeleteProduct(row.product.value)}
                            >
                              <Button
                                color="red"
                                size="xs"
                                style={{ fontSize: 8, padding: 2, height: 15 }}
                              >
                                Remove
                              </Button>
                            </td>
                          </tr>
                        ))}
                      </>
                    ) : null}
                  </tbody>
                </table>
              </Paper>
            </div>
            <Divider my="xs" />
            <Grid gutter="xs">
              <Grid.Col span={9}>
                <Grid>
                  <Grid.Col span={3} pb={0} pt={1}>
                    <TextInput
                      size="xs"
                      ml={5}
                      variant="filled"
                      value={variables.invoiceDiscount}
                      onChange={(e) =>
                        setVariables({
                          ...variables,
                          invoiceDiscount: e.target.value,
                        })
                      }
                      label="Total Discount"
                      placeholder="Total Discount"
                    />
                  </Grid.Col>
                  <Grid.Col span={3} pb={0} pt={1}>
                    {" "}
                    <TextInput
                      size="xs"
                      variant="filled"
                      value={variables.amountPaid}
                      label="Amount Paid"
                      onChange={(e) =>
                        setVariables({
                          ...variables,
                          amountPaid: e.target.value,
                        })
                      }
                      placeholder="Amount Paid"
                    />
                  </Grid.Col>
                  <Grid.Col span={3} pb={0} pt={1}>
                    <TextInput
                      size="xs"
                      ml={5}
                      variant="filled"
                      readOnly
                      value={
                        cart.reduce(function (sum, current) {
                          return +Number(sum) + Number(current.total);
                        }, 0) +
                        cart.reduce(function (sum, current) {
                          return +Number(sum) + Number(current.tax);
                        }, 0) -
                        (Number(variables.amountPaid) +
                          Number(variables.invoiceDiscount))
                      }
                      label="Balance"
                      placeholder="Balance"
                    />
                  </Grid.Col>
                  <Grid.Col span={3} pt={1}>
                    <Select
                      required
                      size="xs"
                      variant="filled"
                      label="Mode of payment"
                      placeholder="Mode Type"
                      data={variables.saleType}
                      value={saleTypeValue}
                      onChange={(e) => {
                        setSaleTypeValue(e);
                      }}
                    />
                  </Grid.Col>
                </Grid>
                <div
                  style={{
                    marginTop: 32,
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <div>
                    <Button
                      disabled={cart.length == 0 ? true : false}
                      color="zevcore"
                      size="xs"
                      onClick={() => handleSaveSale()}
                    >
                      Save Invoice
                    </Button>
                    <Button
                      ml={5}
                      color="zevcore"
                      size="xs"
                      onClick={() => setSavedModal(true)}
                    >
                      View Saved
                    </Button>
                  </div>

                  <Button
                    color="zevcore"
                    disabled={cart.length == 0 ? true : false}
                    size="xs"
                    onClick={() => AddSaleData()}
                  >
                    Add Invoice
                  </Button>
                </div>
              </Grid.Col>

              <Grid.Col span={3} mt={4}>
                <table className="tableBorder">
                  <tbody>
                    <tr>
                      <td>Sub-Total</td>
                      <td>
                        ₹
                        {cart.reduce(function (sum, current) {
                          return +Number(sum) + Number(current.total);
                        }, 0)}
                      </td>
                    </tr>
                    <tr>
                      <td>CGST</td>
                      <td>
                        ₹
                        {cart
                          .reduce(function (sum, current) {
                            return +Number(sum) + Number(current.tax);
                          }, 0)
                          .toFixed(2) / 2}
                      </td>
                    </tr>
                    <tr>
                      <td>SGST</td>
                      <td>
                        ₹
                        {cart
                          .reduce(function (sum, current) {
                            return +Number(sum) + Number(current.tax);
                          }, 0)
                          .toFixed(2) / 2}
                      </td>
                    </tr>
                    <tr>
                      <td>Discount Amount</td>
                      <td>₹{Number(variables.invoiceDiscount).toFixed(2)}</td>
                    </tr>
                    <tr
                      style={{
                        backgroundColor: "#043c64",
                        fontWeight: 500,
                        color: "#ffffff",
                      }}
                    >
                      <td>Grand Total</td>
                      <td>
                        {" "}
                        ₹
                        {Math.round(
                          cart.reduce(function (sum, current) {
                            return +Number(sum) + Number(current.total);
                          }, 0) +
                            cart.reduce(function (sum, current) {
                              return +Number(sum) + Number(current.tax);
                            }, 0) -
                            Number(variables.invoiceDiscount)
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Grid.Col>
            </Grid>
          </Card>
        </Grid.Col>
      </Grid>
      <Modal
        withCloseButton={false}
        overlayOpacity={0.55}
        padding={0}
        overlayBlur={3}
        size="xl"
        opened={variables.addDrawer}
      >
        {/* Drawer content */}
        <div
          style={{
            display: "flex",
            padding: 0,
            margin: 0,
            justifyContent: "space-between",
            background: "#043c64",
            borderTopRightRadius: 3,
            borderTopLeftRadius: 3,
          }}
        >
          <Text color="#ffffff" size={14} m={5} mt={8} ml={15}>
            Add Customer
          </Text>
          <ActionIcon
            onClick={() => setVariables({ ...variables, addDrawer: false })}
            m={5}
            sx={{
              "&[data-disabled]": { opacity: 1 },
              "&[data-loading]": { backgroundColor: "#ffffff" },
            }}
          >
            <X size={18} />
          </ActionIcon>
        </div>
        {/* Drawer content */}
        <div className="zc-p-3">
          <ScrollArea
            // style={{
            //   height: "90vh",
            // }}
            type="scroll"
            offsetScrollbars
            scrollbarSize={5}
          >
            <div className=" zc-pl-3">
              {/* Customer adding form name */}
              <form
                onSubmit={formCustomer.onSubmit((values) =>
                  AddCustomer(values)
                )}
              >
                <Grid>
                  <Grid.Col md={6} lg={6} mt={1}>
                    <TextInput
                      required
                      variant="filled"
                      value={formCustomer.values.name}
                      label="Customer Name"
                      placeholder="Customer Name"
                      {...formCustomer.getInputProps("name")}
                    />
                  </Grid.Col>
                  <Grid.Col md={6} lg={6} mt={1}>
                    <TextInput
                      variant="filled"
                      value={formCustomer.values.phone_number}
                      label="Phone Number"
                      placeholder="Phone Number"
                      {...formCustomer.getInputProps("phone_number")}
                    />
                  </Grid.Col>
                  <Grid.Col md={6} lg={6} mt={1}>
                    <NumberInput
                      variant="filled"
                      value={formCustomer.values.credit_limit}
                      label="Credit Limit"
                      placeholder="Credit Limit"
                      {...formCustomer.getInputProps("credit_limit")}
                    />
                  </Grid.Col>
                  <Grid.Col md={6} lg={6} mt={1}>
                    <TextInput
                      variant="filled"
                      value={formCustomer.values.gstin}
                      label="Customer GSTIN"
                      placeholder="Customer GSTIN"
                      {...formCustomer.getInputProps("gstin")}
                    />
                  </Grid.Col>
                  <Grid.Col md={6} lg={6} mt={1}>
                    <TextInput
                      variant="filled"
                      value={formCustomer.values.door_no}
                      label=" Door No"
                      placeholder=" Door No"
                      {...formCustomer.getInputProps("door_no")}
                    />
                  </Grid.Col>
                  <Grid.Col md={6} lg={6} mt={1}>
                    <TextInput
                      variant="filled"
                      value={formCustomer.values.street}
                      label=" Street"
                      placeholder=" Street"
                      {...formCustomer.getInputProps("street")}
                    />
                  </Grid.Col>
                  <Grid.Col md={6} lg={6} mt={1}>
                    <NumberInput
                      variant="filled"
                      value={formCustomer.values.pincode}
                      label="Pincode"
                      placeholder="Pincode"
                      {...formCustomer.getInputProps("pincode")}
                    />
                  </Grid.Col>
                  <Grid.Col md={6} lg={6} mt={1}>
                    <TextInput
                      variant="filled"
                      value={formCustomer.values.locality}
                      label=" Locality"
                      placeholder=" Locality"
                      {...formCustomer.getInputProps("locality")}
                    />
                  </Grid.Col>
                  <Grid.Col md={6} lg={6} mt={1}>
                    <TextInput
                      variant="filled"
                      value={formCustomer.values.city}
                      label=" City"
                      placeholder=" City"
                      {...formCustomer.getInputProps("city")}
                    />
                  </Grid.Col>
                  <Grid.Col md={6} lg={6} mt={1}>
                    <TextInput
                      variant="filled"
                      value={formCustomer.values.state}
                      label=" State"
                      placeholder=" State"
                      {...formCustomer.getInputProps("state")}
                    />
                  </Grid.Col>
                  <Grid.Col md={12} lg={12} mt={1}>
                    <Button
                      mt="xl"
                      type="submit"
                      fullWidth
                      color="zevcore"
                      loading={variables.submitLoading}
                    >
                      Submit
                    </Button>
                  </Grid.Col>
                </Grid>
              </form>
            </div>
          </ScrollArea>
        </div>
      </Modal>
      <Modal
        withCloseButton={false}
        overlayOpacity={0.55}
        padding={0}
        overlayBlur={3}
        size={"60%"}
        opened={detailsModal}
        onClose={() => setDetailModal(false)}
      >
        <div>
          <div
            style={{
              display: "flex",
              padding: 0,
              margin: 0,
              justifyContent: "space-between",
              background: "#043c64",
              borderTopRightRadius: 3,
              borderTopLeftRadius: 3,
            }}
          >
            <Text color="#ffffff" m={5} mt={7} ml={15}>
              Additional details
            </Text>
            <ActionIcon
              onClick={() => setDetailModal(false)}
              m={5}
              sx={{
                "&[data-disabled]": { opacity: 1 },
                "&[data-loading]": { backgroundColor: "#ffffff" },
              }}
            >
              <X size={18} />
            </ActionIcon>
          </div>
          <div
            style={{
              padding: 15,
            }}
          >
            <Grid>
              <Grid.Col span={4}>
                <TextInput
                  variant="filled"
                  value={formDetails.values.deliver_note}
                  label="Delivery Note"
                  placeholder="Delivery Note"
                  {...formDetails.getInputProps("deliver_note")}
                />
              </Grid.Col>
              <Grid.Col span={4}>
                <TextInput
                  variant="filled"
                  value={formDetails.values.deliver_note}
                  label="Delivery Note"
                  placeholder="Delivery Note"
                  {...formDetails.getInputProps("deliver_note")}
                />
              </Grid.Col>
              <Grid.Col span={4}>
                {" "}
                <TextInput
                  variant="filled"
                  value={formDetails.values.suppliers_ref}
                  label="Supplier's Ref"
                  placeholder="Supplier's Ref"
                  {...formDetails.getInputProps("suppliers_ref")}
                />
              </Grid.Col>
              <Grid.Col span={4}>
                <TextInput
                  variant="filled"
                  value={formDetails.values.other_ref}
                  label="Other Ref"
                  placeholder="Other Ref"
                  {...formDetails.getInputProps("other_ref")}
                />
              </Grid.Col>
              <Grid.Col span={4}>
                {" "}
                <TextInput
                  variant="filled"
                  value={formDetails.values.buyer_order_no}
                  label="Buyer's Order No."
                  placeholder="Buyer's Order No."
                  {...formDetails.getInputProps("buyer_order_no")}
                />
              </Grid.Col>
              <Grid.Col span={4}>
                <TextInput
                  variant="filled"
                  value={formDetails.values.dated}
                  label="Dated"
                  placeholder="dd/mm/yyyy"
                  {...formDetails.getInputProps("dated")}
                />
              </Grid.Col>
              <Grid.Col span={4}>
                <TextInput
                  variant="filled"
                  value={formDetails.values.despatch_doc_no}
                  label="Despatch Document No."
                  placeholder="Despatch Document No."
                  {...formDetails.getInputProps("despatch_doc_no")}
                />
              </Grid.Col>

              <Grid.Col span={4}>
                {" "}
                <TextInput
                  variant="filled"
                  value={formDetails.values.delivery_note_date}
                  label="Deliver Note Date"
                  placeholder="Deliver Note Date"
                  {...formDetails.getInputProps("delivery_note_date")}
                />
              </Grid.Col>
              <Grid.Col span={4}>
                {" "}
                <TextInput
                  variant="filled"
                  value={formDetails.values.despatched_through}
                  label="Despatched Through"
                  placeholder="Despatched Through"
                  {...formDetails.getInputProps("despatched_through")}
                />
              </Grid.Col>
              <Grid.Col span={4}>
                {" "}
                <TextInput
                  variant="filled"
                  value={formDetails.values.destination}
                  label="Destination"
                  placeholder="Destination"
                  {...formDetails.getInputProps("destination")}
                />
              </Grid.Col>
              <Grid.Col span={4}>
                <TextInput
                  variant="filled"
                  value={formDetails.values.terms_of_delivery}
                  label="Terms Of Delivery"
                  placeholder="Terms Of Delivery"
                  {...formDetails.getInputProps("terms_of_delivery")}
                />
              </Grid.Col>
              <Grid.Col span={4}>
                <TextInput
                  variant="filled"
                  value={formDetails.values.remark}
                  label="Remark"
                  placeholder="Remark"
                  {...formDetails.getInputProps("remark")}
                />
              </Grid.Col>
            </Grid>

            <Group position="right" mt="md" mb="lg">
              <Button
                type="submit"
                color="zevcore"
                onClick={() => setDetailModal(false)}
              >
                Submit
              </Button>
            </Group>
          </div>
        </div>
      </Modal>
      <Modal
        withCloseButton={false}
        overlayOpacity={0.55}
        padding={0}
        overlayBlur={3}
        onClose={() => setSavedModal(false)}
        size={"90%"}
        opened={savedModal}
      >
        <div>
          <div
            style={{
              display: "flex",
              padding: 0,
              margin: 0,
              justifyContent: "space-between",
              background: "#043c64",
              borderTopRightRadius: 3,
              borderTopLeftRadius: 3,
            }}
          >
            <Text color="#ffffff" size={14} m={5} mt={8} ml={15}>
              Saved Invoices
            </Text>

            <ActionIcon
              onClick={() => setSavedModal(false)}
              m={5}
              sx={{
                "&[data-disabled]": { opacity: 1 },
                "&[data-loading]": { backgroundColor: "#ffffff" },
              }}
            >
              <X size={18} />
            </ActionIcon>
          </div>
          <div style={{ padding: 15 }}>
            <ScrollArea>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                {/* For search the table data input forms */}
                <TextInput
                  variant="filled"
                  placeholder="Search by any field"
                  mb="md"
                  size="xs"
                  value={search}
                  icon={<Search size={14} />}
                  onChange={async (e) => {
                    // On change search ofr the data that is enter
                    setSearch(e.currentTarget.value);
                    setPage(1);
                    const datas = await dataSearch({
                      data: variables.data,
                      value: e.currentTarget.value,
                      activePage: activePage,
                      total: total,
                    });
                    setSortedData(datas);
                    setRefreshTable(new Date());
                  }}
                  sx={{ width: 250 }}
                />
                <div></div>
              </div>
              {/* Table data view */}
              <Table
                horizontalSpacing="md"
                verticalSpacing="xs"
                className={classes.striped}
              >
                {/* Table header defines */}
                <thead>
                  <tr>
                    <Th>Sl.No</Th>
                    <Th>Invoice</Th>
                    <Th>Customer</Th>
                    <Th>Discount</Th>
                    <Th>Subtotal</Th>
                    <Th>CGST</Th>
                    <Th>SGST</Th>
                    <Th>Total</Th>
                    <Th>Created At</Th>
                    <Th>Load</Th>
                    <Th>Action</Th>
                  </tr>
                </thead>
                {/* Table body defines from rows function */}
                <tbody key={refreshTable}>
                  {rows.length > 0 ? (
                    rows
                  ) : (
                    <tr>
                      <td>
                        <Text align="center">Nothing found</Text>
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </ScrollArea>
            {/* For display the pagination and no of per pages list */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                paddingTop: 15,
              }}
            >
              {/* For number of rows display in table */}
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Text size="sm" className="zc-pr-3 zc-pt-1">
                  Per Page
                </Text>
                <NativeSelect
                  size="xs"
                  onChange={async (e) => {
                    setTotal(Number(e.currentTarget.value));
                    setPage(1);
                    const datas = await dataSlice({
                      data: variables.data,
                      page: 1,
                      total: Number(e.currentTarget.value),
                    });
                    setSortedData(datas);
                    setRefreshTable(new Date());
                  }}
                  data={["10", "20", "50", "100"]}
                  rightSectionWidth={20}
                  sx={{ width: 70 }}
                />
              </div>
              {/* For pagination */}
              <Pagination
                size="xs"
                page={activePage}
                onChange={async (e) => {
                  setPage(Number(e));
                  const datas = await dataSlice({
                    data: variables.data,
                    page: Number(e),
                    total: total,
                  });
                  setSortedData(datas);
                  setRefreshTable(new Date());
                }}
                total={Math.ceil(variables.data.length / total)}
                color="zevcore"
              />
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default AddSale;
